import { PaginatedLiabilityInsuranceQueryVariables } from "@/graphql/__generated__/graphql";
import ValueRangeFilter from "../../Shared/ValueRangeFilter";

interface Props {
  displayAmount: number;
  handleSubmitClick: (_variables?: PaginatedLiabilityInsuranceQueryVariables) => void;
}

/**
 * LiabilityInsuranceValueRange component for filtering liability insurance by value ranges
 * Handles both liabilityInsurance and professionalAssociation value range filters
 * @param props Component properties
 * @returns JSX element
 */
function LiabilityInsuranceValueRange({ displayAmount, handleSubmitClick }: Props) {
  const liabilityInsuranceValueConfig = {
    paginationStateKey: "paginatedLiabilityInsurance" as keyof PaginationState,
    fields: [
      {
        fieldName: "liabilityInsurance",
        labelKey: "components:filters.liabilityInsurance.sortfields.liabilityInsurance",
        inputStyle: "decimal" as const,
        useBasisPoints: true,
        suffix: "%",
        decimalScale: 2,
        placeholder: "0.00"
      },
      {
        fieldName: "professionalAssociation",
        labelKey: "components:filters.liabilityInsurance.sortfields.professionalAssociation",
        inputStyle: "decimal" as const,
        useBasisPoints: true,
        suffix: "%",
        decimalScale: 2,
        placeholder: "0.00"
      }
    ],
    defaultButtonTextKey: "components:filters.liabilityInsurance.valueRange",
    buildQueryVariables: (
      displayAmount: number,
      filters: any,
      valueRanges: Record<string, { gte: number | null; lte: number | null }>,
      sort?: any
    ): PaginatedLiabilityInsuranceQueryVariables => ({
      first: displayAmount,
      filters: {
        activeFrom: filters.activeFrom || null,
        liabilityInsurance: valueRanges.liabilityInsurance,
        professionalAssociation: valueRanges.professionalAssociation
      },
      sort: sort
    }),
    extractFilters: (paginationState: any) => ({
      activeFrom: paginationState.filters?.activeFrom,
      liabilityInsurance: paginationState.filters?.liabilityInsurance,
      professionalAssociation: paginationState.filters?.professionalAssociation,
    })
  };

  return (
    <ValueRangeFilter
      displayAmount={displayAmount}
      handleSubmitClick={handleSubmitClick}
      config={liabilityInsuranceValueConfig}
    />
  );
}

export default LiabilityInsuranceValueRange;
